import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  get token() {
    return localStorage.getItem("fp_token");
  },
  get user() {
    const raw = localStorage.getItem("fp_user");
    return raw ? JSON.parse(raw) : null;
  },
  save(token, user) {
    localStorage.setItem("fp_token", token);
    localStorage.setItem("fp_user", JSON.stringify(user));
  },
  logout() {
    localStorage.removeItem("fp_token");
    localStorage.removeItem("fp_user");
  },
};
